import React, { useReducer, useState } from 'react';
import { Segment, Form, Header, Input, Icon } from 'semantic-ui-react';
import InputMask from 'react-input-mask';
import history from 'services/history';

const initialFormValues = {
    dataInicio: '',
    dataFim: '',
};

function formReducer(state, action) {
    if ('reset' in action) return initialFormValues;
    if (!('payload' in action)) return state;
    return { ...state, ...action.payload };
}

export default function Formulario(props) {
    const [form, setForm] = useReducer(formReducer, initialFormValues);
    const [, setDados] = useState([]);
    const [isSubmitting] = useState(false);

    function handleChange(event) {
        let name, value;
        [name, value] = [event.target.name, event.target.value];
        setForm({ payload: { [name]: value } });
    }

    const cleanPath = () => {
        history.push({ search: null });
        setDados([]);
    };

    return (
        <div className="col d-flex align-items-center flex-column">
            <Segment basic textAlign="left" style={{ width: '100%', padding: '10px 0px' }}>
                <Form size={'tiny'}>
                    <Form.Group>
                        <Form.Field width="4">
                            <Header
                                floated="left"
                                as="h5"
                                style={{ margin: 0, marginBottom: 5 }}
                                color="orange"
                            >
                                Data
                            </Header>
                            <Header
                                floated="right"
                                as="h5"
                                style={{ margin: 0, marginBottom: 5, color: 'white' }}
                            >
                                -
                            </Header>
                            <Input
                                children={
                                    <InputMask
                                        mask="99/99/9999"
                                        placeholder="Inicial"
                                        value={form.dataInicio}
                                        name="dataInicio"
                                        onChange={handleChange}
                                    />
                                }
                            />
                        </Form.Field>
                        <Form.Field width="4">
                            <Header
                                floated="right"
                                as="h5"
                                style={{ margin: 0, marginBottom: 5, color: 'white' }}
                            >
                                -
                            </Header>
                            <Input
                                children={
                                    <InputMask
                                        mask="99/99/9999"
                                        placeholder="Final"
                                        value={form.dataFim}
                                        name="dataFim"
                                        onChange={handleChange}
                                    />
                                }
                            />
                        </Form.Field>
                        <Form.Button
                            label={'\u00A0'}
                            floated="right"
                            width="2"
                            icon
                            title="Limpar Campos"
                            type="button"
                            onClick={() => {
                                setForm({ reset: true });
                                cleanPath();
                            }}
                        >
                            <Icon name="trash" />
                        </Form.Button>
                        <Form.Button
                            label={'\u00A0'}
                            disabled={isSubmitting}
                            floated="right"
                            icon
                            labelPosition="left"
                            color="vk"
                        >
                            <Icon name="arrow right" />
                            Enviar
                        </Form.Button>
                    </Form.Group>
                </Form>
            </Segment>
        </div>
    );
}
